import { Component } from 'react'
import firstAutoShipDiscounts, {
  setFirstAutoshipDiscountOrderMetadata
} from '../utils/firstAutoShipDiscounts'

export default class Discounts extends Component {
  evaluateCartItemsFirstAutoShipDiscount = () => {
    const totalDiscount = 0
    window.Snipcart.api.items.all().forEach(async cartItem => {
      const { metadata, id, originalPrice } = cartItem
      const hasAutoship =
        metadata && 'autoship' in metadata && metadata.autoship
      const hasFirstAutoShipDiscount =
        metadata && 'first_autoship' in metadata && metadata.first_autoship
      if (hasAutoship && !hasFirstAutoShipDiscount) {
        const productDiscountedPrice = await firstAutoShipDiscounts(
          originalPrice
        )
        if (productDiscountedPrice) {
          const encodedPriceValidationInfo = btoa(
            JSON.stringify({
              id,
              price: Number(productDiscountedPrice)
            })
          )
          window.Snipcart.api.items.update(id, {
            price: productDiscountedPrice,
            url: `${process.env.REACT_APP_SNIPCART_VALIDATOR_DOMAIN}${encodedPriceValidationInfo}`,
            metadata: {
              ...metadata,
              original_price: originalPrice,
              first_autoship: true
            }
          })
          await setFirstAutoshipDiscountOrderMetadata(
            Number(originalPrice),
            Number(productDiscountedPrice),
            id
          )
        }
      }
    })
  }
}
